<template>
  <main class="about">
    <h1>This is an about page</h1>
  </main>
</template>

<script>
export default {
  
  
}
</script>